import { Skeleton } from 'shadcn/components/ui/Skeleton';

function EditorLoadingSkeleton() {
    return (
        <>
            <div className="w-full h-13" />
            <div className="fixed top-[64px] h-[73px] flex justify-center gap-2 w-screen border-b px-4 -ml-5 bg-[#F6F6F6] z-50">
                <div className="flex-1 flex items-center gap-4 w-full max-w-7xl">
                    <div className=" flex-1 flex items-center gap-3 min-w-0">
                        <Skeleton className="w-22 h-10" />
                        <Skeleton className="w-80 h-10" />
                    </div>
                    <div className="flex items-center gap-3">
                        <Skeleton className="w-44 h-5" />
                        <Skeleton className="w-30 h-10" />
                        <Skeleton className="w-25 h-10" />
                        <Skeleton className="w-9 h-10" />
                    </div>
                </div>
            </div>

            <section className="flex w-full gap-4 max-w-7xl mx-auto">
                <div className="shrink-0 w-100" />
                <div className="fixed top-34 bottom-0 w-100 overflow-y-auto">
                    <div className="flex flex-col gap-6 pt-4 pr-6 pb-16 pl-1">
                        <Skeleton className="w-full h-12" />
                        <Skeleton className="w-full h-50" />
                        <Skeleton className="w-full h-30" />
                        <Skeleton className="w-full h-40" />
                    </div>
                </div>
                <div className="flex flex-col gap-6 pt-4 pb-12 w-full min-w-0">
                    <Skeleton className="w-full h-56" />
                    <Skeleton className="w-full h-120" />
                </div>
            </section>
        </>
    );
}

export default EditorLoadingSkeleton;
